/*
Menu Types:
"menu-default", "menu-sub-hidden", "menu-hidden"
*/
export const defaultMenuType = "menu-sub-hidden";

export const subHiddenBreakpoint = 1440;
export const menuHiddenBreakpoint = 768;
export const defaultLocale = "en";
export const localeOptions = [
  { id: "en", name: "English - LTR", direction: "ltr" },
  { id: "es", name: "Español", direction: "ltr" },
  { id: "enrtl", name: "English - RTL", direction: "rtl" },
];

export const firebaseConfig = {
  apiKey: "AIzaSyBBksq-Asxq2M4Ot-75X19IyrEYJqNBPcg",
  authDomain: "gogo-react-login.firebaseapp.com",
  databaseURL: "https://gogo-react-login.firebaseio.com",
  projectId: "gogo-react-login",
  storageBucket: "gogo-react-login.appspot.com",
  messagingSenderId: "216495999563",
};
export const infoKey = "LoginUser";
export const searchPath = "/app/pages/search";
export const servicePath = "https://api.coloredstrategies.com";

export const apiUrl = () => {
  const { location } = window;
  if (location.hostname === "localhost") {
    return `http://localhost:4000/api/admin/v1`;
  }
  return "https://app.rooms.rentals/api/admin/v1";
};

/*
Color Options:
"light.purple", "light.blue", "light.green", "light.orange", "light.red", "dark.purple", "dark.blue", "dark.green", "dark.orange", "dark.red"
*/
export const themeColorStorageKey = "__theme_color";
export const isMultiColorActive = true;
export const defaultColor = "light.orange";
export const isDarkSwitchActive = true;
export const defaultDirection = "ltr";
export const themeRadiusStorageKey = "__theme_radius";
export const isDemo = false;

export const convertDate = (timestamp) => {
  const today = new Date(timestamp * 1000);
  let dd = today.getDate();
  let mm = today.getMonth() + 1; //January is 0!

  var yyyy = today.getFullYear();
  if (dd < 10) {
    dd = "0" + dd;
  }
  if (mm < 10) {
    mm = "0" + mm;
  }
  return dd + "-" + mm + "-" + yyyy;
};

const addZero = (value) => {
  if (value <= 9) {
    return `0${value}`;
  }
  return value;
};

export const convertDateTime = (timestamp) => {
  const today = new Date(timestamp * 1000);
  let dd = today.getDate();
  let mm = today.getMonth() + 1; //January is 0!

  var yyyy = today.getFullYear();
  if (dd < 10) {
    dd = "0" + dd;
  }
  if (mm < 10) {
    mm = "0" + mm;
  }
  return `${dd}-${mm}-${yyyy} ${addZero(today.getHours())}:${addZero(
    today.getMinutes()
  )}`;
};

export const additional = {
  currentPage: 1,
  totalItemCount: 0,
  totalPage: 1,
  search: "",
  pageSizes: [10, 20, 50, 100],
};

export const quillModules = {
  toolbar: [
    ["bold", "italic", "underline", "strike"], // toggled buttons
    ["blockquote", "code-block"],
    ["link", "image", "video", "formula"],

    [{ header: 1 }, { header: 2 }], // custom button values
    [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
    [{ script: "sub" }, { script: "super" }], // superscript/subscript
    [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
    [{ direction: "rtl" }], // text direction

    [{ size: ["small", false, "large", "huge"] }], // custom dropdown
    [{ header: [1, 2, 3, 4, 5, 6, false] }],

    [{ color: [] }, { background: [] }], // dropdown with defaults from theme
    [{ font: [] }],
    [{ align: [] }],

    ["clean"],
  ],
};

export const searchType = {
  room: "room",
  entireHome: "entireHome",
  roommates: "roommates",
  tenants: "tenants",
};
export const searchRoutes = {
  room: "/rooms-for-rent",
  entireHome: "/apartments-for-rent",
  roommates: "/roommates",
  tenants: "/apartments-wanted",
};

export const apiSearchType = {
  room: "offering-room",
  entireHome: "offering-apartment",
  roommates: "need-room",
  tenants: "need-apartment",
};

export const viewEndPoints = {
  "offering-room": "offering-room",
  "offering-apartment": "offering-apartment",
  "need-room": "need-room",
  "need-apartment": "need-apartment",
};

export const editEndPoints = {
  "offering-room": "/edit-room",
  "offering-apartment": "/edit-apartment",
  "need-room": "/edit-need-rooms",
  "need-apartment": "/edit-tenants",
};

export const dataKeyName = {
  "offering-room": "need-rooms",
  "offering-apartment": "need-apartment",
  "need-room": "need-rooms",
  "need-apartment": "need-tenant",
};

export const defaultImage = {
  room: "/assets/img/bed.jpg",
  entireHome: "/assets/img/bed.jpg",
  roommates: "/assets/img/bedUser.png",
  tenants: "/assets/img/bedUser.png",
};

export const defaultRoomText = {
  room: "Offering a Room",
  entireHome: "Bedroom(s):",
  roommates: `Looking for Room`,
  tenants: "Looking Entire Home",
};

export const userAccountTypes = {
  "offering-room": "room",
  "offering-apartment": "entireHome",
  "need-room": "roommates",
  "need-apartment": "tenants",
};

export const loginRedirectType = {
  "offering-room": "roommates",
  "offering-apartment": "tenants",
  "need-room": "room",
  "need-apartment": "entireHome",
};

export const offerTypeText = {
  room: "Available: Now",
  entireHome: "Available: Now",
  roommates: "Move-In Date: Immediately",
  tenants: "Move-In Date: Immediately",
};
export const detailsPage = {
  room: "offering-room",
  entireHome: "offering-apartment",
  roommates: "need-room",
  tenants: "need-apartment",
};

export const defaultDescription = {
  "offering-room": (firstname) =>
    `Hello, My name is ${firstname}, I have a room available for rent. If you are interested, please get in touch with me for more information, or to arrange a viewing. Thanks!`,
  "offering-apartment": (firstname) =>
    `Hello, My name is ${firstname}, I have an entire home available for rent. If interested, please get in touch with me for more information and to arrange a viewing. Thanks.`,
  "need-room": (firstname) =>
    ` Hello, My name is ${firstname}, I'm looking for a room. If you are interested in my profile, please get in touch. Thanks!`,
  "need-apartment": (firstname) =>
    ` Hello, My name is ${firstname}, I'm looking for a entire home. If you are interested in my profile, please get in touch. Thanks!`,
};
export const newProperties = {
  studio: "Studio",
  apartment: "Apartment",
  sublet: "Sublet",
  house: "House",
  flat: "Flat",
  condo: "Condo",
};

export const propertyType = {
  apartment: "Apartment",
  flat: "Flat",
  house: "House",
  studio: "Studio",
  condo: "Condo",
  townhouse: "Town House",
  "basement-apartment": "Basement Apartment",
  "bachelor-apartment": "Bachelor Apartment",
  bungalow: "Bungalow",
  loft: "Loft",
  "semi-detached": "Semi Detached",
  duplex: "Duplex",
  sublet: "Sublet",
  asylum: "Asylum",
  dormitory: "Dormitory",
  "nursing-home": "Nursing Home",
  villa: "Villa",
  "dorm-style": "Dorm Style",
  "multi-family": "Multi Family",
  "brown-house": "Brown House",
  "mobile-home": "Mobile Home",
  "detached-house-home": "Detached House",
  "semi-detached-house": "Semi Detached House",
  "terraced-house": "Terraced House",
  "boat-house": "Mobile Home",
  other: "Other",
};
export const liveWith = {
  1: "With No-one",
  2: "With Anyone",
  3: "With Male",
  4: "With Female",
};

export const getUpTimes = {
  1: "Before 6AM",
  2: "6AM - 8AM",
  3: "8AM - 10AM",
  4: "10AM - 12PM",
  5: "After 12PM",
};

export const goToBed = {
  1: "Before 8PM",
  2: "8PM - 10PM",
  3: "10PM - 12AM",
  4: "12AM - 2AM",
  5: "After 2AM",
};

export const amentiasValues = [
  { image: "/assets/img/wifi.svg", text: "Internet/Wifi", dbName: "internet" },
  {
    image: "/assets/img/ac.svg",
    text: "Air Conditioning",
    dbName: "high_rise",
  },
  { image: "/assets/img/tv.svg", text: "Tv", dbName: "garage" },
  { image: "/assets/img/lift.svg", text: "Elevator", dbName: "elevator" },
  { image: "/assets/img/garden.svg", text: "Garden", dbName: "health_club" },
  {
    image: "/assets/img/balconi.svg",
    text: "Terrace/Balcony",
    dbName: "low_rise",
  },
  {
    image: "/assets/img/fridge.svg",
    text: "Fridge/Freezer",
    dbName: "laundromat",
  },
  { image: "/assets/img/gym.svg", text: "Gym", dbName: "doorman" },
  {
    image: "/assets/img/parking.svg",
    text: "Parking/Garage",
    dbName: "parking_lot",
  },
  {
    image: "/assets/img/washingmachine.svg",
    text: "Washing Machine",
    dbName: "electronic_security",
  },
  {
    image: "/assets/img/dishwasher.svg",
    text: "Dishwasher",
    dbName: "washer_dryer",
  },
  {
    image: "/assets/img/heater.svg",
    text: "Heating",
    dbName: "street_parking",
  },
  {
    image: "/assets/img/dryer.svg",
    text: "Dryer",
    dbName: "wireless_internet",
  },
  {
    image: "/assets/img/pool.svg",
    text: "Swimming Pool",
    dbName: "swimming_pool",
  },
  {
    image: "/assets/img/bathroom.svg",
    text: "Private Bathroom",
    dbName: "near_subway",
  },
];

export const occupation = {
  1: "Accounting",
  2: "Administration/ Secretarial",
  3: "Advertising",
  4: "Architecture/ Design",
  5: "Automotive/ Mechanical",
  6: "Aviation/ Aeronautical",
  7: "Beauty/ Fashion",
  8: "Biology/ Life Science",
  9: "Broadcasting/ Publishing",
  10: "Consulting",
  11: "Customer Service/ Support",
  12: "Creative/ Media",
  13: "Education/ Training",
  14: "Engineering",
  15: "Finance/ Banking",
  16: "Government/ Social Service",
  17: "Health Services",
  18: "Hospitality",
  19: "Human Resources/ Recruiting",
  20: "IT/Computers",
  21: "Insurance",
  22: "Internet/Media",
  23: "Law Enforcement/ Security",
  24: "Legal",
  25: "Manufacturing/ Production",
  26: "Marketing/ Public Relations",
  27: "Military",
  28: "Non-Profit",
  29: "Other",
  30: "Physical Science/ Environment",
  31: "Real Estate",
  32: "Retail",
  33: "Sales",
  34: "Sports/ Fitness",
  35: "Student/ Graduate",
  36: "Student/ Undergraduate",
  37: "Telecommunications",
  38: "Trades/ Labor",
  39: "Transportation/ Logistic",
};

export const signupOccupation = {
  Student: "Student",
  Professional: "Professional",
  Retired: "Retired",
  "House Benefits": "House Benefits",
  DSS: "DSS",
  Others: "Others",
};
export const pets = {
  dogs: "Dogs",
  cats: "Cats",
  birds: "Birds",
  fish: "Fish",
  reptiles: "Reptiles",
  no_pets: "No Pets",
  "small-pets": "Small Pets",
};
export const bedRooms = {
  1: "1 Bedroom",
  2: "2 Bedrooms",
  3: "3 Bedrooms",
  4: "4 Bedrooms",
  5: "5 Bedrooms",
  6: "6+ Bedrooms",
};

export const advertizing = {
  owner: "Owner",
  management: "Management",
  tenant: "Tenant",
  broker: "Live-In Landlord",
};

export const roomTypes = {
  single: "Single",
  "double-room": "Double Room",
  "private-room": "Private Room",
  twin: "Twin",
  shared: "Shared Room",
  other: "Other",
};

export const whoLiveThere = [
  {
    name: "1 Person",
    value: "1 Person",
  },
  {
    name: "2 Person",
    value: "2 Person",
  },
  {
    name: "3 Person",
    value: "3 Person",
  },
  {
    name: "4 Person",
    value: "4 Person",
  },
  {
    name: "5 Person",
    value: "5 Person",
  },
  {
    name: "6 Person",
    value: "6 Person",
  },
  {
    name: "7 Person",
    value: "7 Person",
  },
  {
    name: "8 Person",
    value: "8 Person",
  },
  {
    name: "9 Person",
    value: "9 Person",
  },
  {
    name: "10 Person",
    value: "10 Person",
  },
];

export const minimumStay = {
  30: "1 month",
  60: "2 months",
  90: "3 months",
  120: "4 months",
  150: "5 months",
  180: "6 months",
  210: "7 months",
  240: "8 months",
  270: "9 months",
  300: "10 months",
  330: "11 months",
  365: "12 months",
};

export const partyHabits = {
  rarely: "Rarely",
  occasionally: "Occasionally",
  weekends: "Weekends",
  daily: "Daily",
};
export const cleanliness = {
  clean: "Clean",
  average: "Average",
  messy: "Messy",
};

export const genderTypes = [
  {
    name: "Male",
    value: "male",
  },
  {
    name: "Female",
    value: "female",
  },
  {
    name: "Male-Female",
    value: "male-female",
  },
  {
    name: `I'd rather not say`,
    value: "other",
  },
];

export const smokeType = {
  yes: "Yes",
  no: "No",
  "outside-only": "Outside only",
};

export const rentType = {
  2: "Per Week Rent",
  3: "Per Month Rent",
};

export const measurementType = {
  "square-meters": "Square Meters",
  "cubic-meters": "Cubic Meters",
};

export const roomyCurrencies = {
  AED: {
    code: "AED",
    name: "United Arab Emirates",
    symbol: "د.إ",
    currency: "Dirham",
    countryCode: "AE",
    rate: "",
  },
  ARS: {
    code: "ARS",
    name: "Argentina",
    symbol: "$",
    currency: "Peso",
    countryCode: "AR",
    rate: "",
  },
  AUD: {
    code: "AUD",
    name: "Australia",
    symbol: "$",
    currency: "Dollar",
    countryCode: "AU",
    rate: "",
  },
  BRL: {
    code: "BRL",
    name: "Brazil",
    symbol: "R$",
    currency: "Real",
    countryCode: "BR",
    rate: "",
  },
  CAD: {
    code: "CAD",
    name: "Canada",
    symbol: "$",
    currency: "Dollar",
    countryCode: "CA",
    rate: "",
  },
  CNY: {
    code: "CNY",
    name: "China",
    symbol: "¥",
    currency: "Yuan Renminbi",
    countryCode: "CN",
    rate: "",
  },
  DKK: {
    code: "DKK",
    name: "Denmark",
    symbol: "kr",
    currency: "Krone",
    countryCode: "DK",
    rate: "",
  },
  EUR: {
    code: "EUR",
    name: "Euro Member",
    symbol: "€",
    currency: "Euro",
    countryCode: [
      "EU",
      "AT",
      "BE",
      "CY",
      "ES",
      "FI",
      "FR",
      "DE",
      "GR",
      "IE",
      "IT",
      "LV",
      "LT",
      "LU",
      "MT",
      "NL",
      "PT",
      "SK",
      "SI",
      "ES",
    ],
    rate: "",
  },
  GBP: {
    code: "GBP",
    name: "United Kingdom",
    symbol: "£",
    currency: "Pound",
    countryCode: "GB",
    rate: "",
  },
  HKD: {
    code: "HKD",
    name: "Hong Kong",
    symbol: "$",
    currency: "Dollar",
    countryCode: "HK",
    rate: "",
  },
  INR: {
    code: "INR",
    name: "India",
    symbol: "₹",
    currency: "Rupee",
    countryCode: "IN",
    rate: "",
  },
  IDR: {
    code: "IDR",
    name: "Indonesia",
    symbol: "Rp",
    currency: "Rupiah",
    countryCode: "ID",
    rate: "",
  },
  ILS: {
    code: "ILS",
    name: "Israel",
    symbol: "₪",
    currency: "Shekel",
    countryCode: "IL",
    rate: "",
  },
  KRW: {
    code: "KRW",
    name: "Korea (South)",
    symbol: "₩",
    currency: "Won",
    countryCode: "KR",
    rate: "",
  },
  MYR: {
    code: "MYR",
    name: "Malaysia",
    symbol: "RM",
    currency: "Ringgit",
    countryCode: "MY",
    rate: "",
  },
  MXN: {
    code: "MXN",
    name: "Mexico",
    symbol: "$",
    currency: "Peso",
    countryCode: "MX",
    rate: "",
  },
  NOK: {
    code: "NOK",
    name: "Norway",
    symbol: "kr",
    currency: "Krone",
    countryCode: "NO",
    rate: "",
  },
  NZD: {
    code: "NZD",
    name: "New Zealand",
    symbol: "$",
    currency: "Dollar",
    countryCode: "NZ",
    rate: "",
  },
  PHP: {
    code: "PHP",
    name: "Philippines",
    symbol: "₱",
    currency: "Peso",
    countryCode: "PH",
    rate: "",
  },
  PLN: {
    code: "PLN",
    name: "Poland",
    symbol: "zł",
    currency: "Zloty",
    countryCode: "PL",
    rate: "",
  },
  RUB: {
    code: "RUB",
    name: "Russia",
    symbol: "₽",
    currency: "Ruble",
    countryCode: "RU",
    rate: "",
  },
  ZAR: {
    code: "ZAR",
    name: "South Africa",
    symbol: "R",
    currency: "Rand",
    countryCode: "ZA",
    rate: "",
  },
  CHF: {
    code: "CHF",
    name: "Switzerland",
    symbol: "CHF",
    currency: "Swiss franc",
    countryCode: "CH",
    rate: "",
  },
  SEK: {
    code: "SEK",
    name: "Sweden",
    symbol: "kr",
    currency: "Krona",
    countryCode: "SE",
    rate: "",
  },
  SGD: {
    code: "SGD",
    name: "Singapore",
    symbol: "$",
    currency: "Dollar",
    countryCode: "SG",
    rate: "",
  },
  THB: {
    code: "THB",
    name: "Thailand",
    symbol: "฿",
    currency: "Baht",
    countryCode: "TH",
    rate: "",
  },
  TRY: {
    code: "TRY",
    name: "Turkey",
    symbol: "₺",
    currency: "Lira",
    countryCode: "TR",
    rate: "",
  },
  TWD: {
    code: "TWD",
    name: "Taiwan",
    symbol: "NT$",
    currency: "New Dollar",
    countryCode: "TW",
    rate: "",
  },
  UAH: {
    code: "UAH",
    name: "Ukraine",
    symbol: "₴",
    currency: "Hryvna",
    countryCode: "UA",
    rate: "",
  },
  USD: {
    code: "USD",
    name: "United States",
    symbol: "$",
    currency: "Dollar",
    countryCode: "US",
    rate: "",
  },
  VND: {
    code: "VND",
    name: "Viet Nam",
    symbol: "₫",
    currency: "Dong",
    countryCode: "VN",
    rate: "",
  },
};
